import React, { useState } from "react";
import { Link } from "react-router-dom";
import SolNft from "../components/nfts/SolNft";

export default function Ethereum() {
    let [collection, setCollection] = useState<string | undefined>();
    let [nfts, setNfts] = useState<any[] | undefined>();

    let degodsNfts = [
        {
            previews: { image_small_url: 'https://img-cdn.magiceden.dev/rs:fill:400:400:0:0/plain/https://metadata.degods.com/g/9589-dead.png' },
            token_id: '9590',
            last_sale: { timestamp: '2022-11-09', unit_price: '169000000000', from_address: '5AzRCCAf4HKWHb1MwkHeZnTjBMaZkktu9UnHb4sJab9o', to_address: 'EeSQBWi2qv4B6Md5DkPJ1MJNSu3hYDMZ6GkwqtCwYGjL'},
        },
        {
            previews: { image_small_url: 'https://img-cdn.magiceden.dev/rs:fill:400:400:0:0/plain/https://metadata.degods.com/g/745-dead.png' },
            token_id: '746',
            last_sale: { timestamp: '2022-11-09', unit_price: '203300000000', from_address: '8sdcPmqHH9cwaD19QnURxLvMnpAahW6D8oSYwjKv5qxV', to_address: 'EXE1NZ7EroF1YTtzzQFHasAKpBKtEPEQXHVDvJeCA1dx'},
        },
        {
            previews: { image_small_url: 'https://img-cdn.magiceden.dev/rs:fill:400:400:0:0/plain/https://metadata.degods.com/g/2308-dead.png' },
            token_id: '2309',
            last_sale: { timestamp: '2022-11-09', unit_price: '169000000000', from_address: '97L3iSFYrRMBsxqnzRQLWkSshviD5uCKdC6Kzyk8uQxa', to_address: '86b9U96EWyyVWTb5TVu2UrX1Ttxvk2Wv9678q5Q9j8Ex'},
        },
        {
            previews: { image_small_url: 'https://img-cdn.magiceden.dev/rs:fill:400:400:0:0/plain/https://metadata.degods.com/g/8654-dead.png' },
            token_id: '8655',
            last_sale: { timestamp: '2022-11-09', unit_price: '169000000000', from_address: '8sdcPmqHH9cwaD19QnURxLvMnpAahW6D8oSYwjKv5qxV', to_address: 'FRURkrX8j5bXYhWng1HzkuFD5ihiGJD78mr6uczhq5cV'},
        },
        {
            previews: { image_small_url: 'https://img-cdn.magiceden.dev/rs:fill:400:400:0:0/plain/https://metadata.degods.com/g/2839-dead.png' },
            token_id: '2840',
            last_sale: { timestamp: '2022-11-09', unit_price: '182000000000', from_address: '2gdPh6u3GiWi9QcBh7pVmB7UbhrKQNYMP2R5WZqd6Exz', to_address: 'C6cM8sDMMUb3Cw4cSeKBrBRDBAuTWtpNrjaJKd5UwBCd'},
        },
    ];

    const loadNfts = async (collection_name: string) => {
        console.log('static data for ' + collection_name);
        setNfts(degodsNfts);
    }

    function loadCollection(name: string) {
        setCollection(name);
        loadNfts(name);
    }

    function resetPage() {
        setNfts(undefined);
        setCollection(undefined);
    }

    return (
        <div className='flexColumn justifyStart' style={{minHeight: '300px'}}>
            {collection ?
                nfts ?
                    <div>
                        <div className='subheading'>{collection.toUpperCase()}</div>
                        <table>
                            <tr>
                                <th></th>
                                <th>id</th>
                                <th>sale date</th>
                                <th>amount</th>
                                <th>from</th>
                                <th>to</th>
                            </tr>
                            <tbody>
                            {nfts.map(nft => (
                                <SolNft key={nft.token_id} nft={nft}/>
                            ))}
                            </tbody>
                        </table>
                        <button className='blueButton' onClick={() => resetPage()}>BACK</button>
                    </div>
                    :
                    <div>loading...</div>
                :
                <div className='flexColumn'>
                    <div className='subheading'>Solana whales</div>
                    <button className='blueButton' onClick={() => loadCollection('degods')}>DeGods</button>
                    <Link style={{marginTop: '20px'}} to='/'><button className='blueButton'>BACK</button></Link>
                </div>
            }

        </div>
    )
}
